module.exports = __webpack_public_path__ + "media/images/front/common/icon_live-17ac1d618aed5b20f4efac93d1f897f5.svg";